import React from 'react';
import { ColourMod } from '../../Data/Enums/LayoutEnums';
import Button from '../Buttons/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faWarning } from '@fortawesome/pro-solid-svg-icons/faWarning';
import { AlertBannerType } from './AlertBannerTypes';
import CloseButton from '../Buttons/CloseButton';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

const AlertBanner = (props: AlertBannerType) => {
	let stateIcon = <FontAwesomeIcon icon={faInfoCircle} fixedWidth={true} />;

	switch (props.colourMod) {
		case ColourMod.Warning:
			stateIcon = <FontAwesomeIcon icon={faWarning} fixedWidth={true} />;
			break;
		case ColourMod.Alert:
			stateIcon = <FontAwesomeIcon icon={faCircleExclamation} fixedWidth={true} />;
			break;
		case ColourMod.Success:
			stateIcon = <FontAwesomeIcon icon={faCheckCircle} fixedWidth={true} />;
			break;
	}

	return (
		<div className={`alert-banner ${props.colourMod}`}>
			<div className='alert-banner-icon'>{props.icon ? props.icon : stateIcon}</div>

			<div className={`alert-banner-content `}>
				{props.title && (
					<div className={`alert-banner-title`} dangerouslySetInnerHTML={{ __html: props.title }} />
				)}
				{props.content && typeof props.content === 'string' && (
					<div dangerouslySetInnerHTML={{ __html: props.content }} />
				)}
				{props.content && typeof props.content !== 'string' && props.content}
			</div>

			{props.addOn && props.addOn}

			{props.closeCallback && <CloseButton onClick={() => props.closeCallback()} />}
		</div>
	);
};

export default AlertBanner;
